import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlineEye, HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { ConfirmationModal, Table } from 'components/Ui'
import { updateApiRecord, deleteApiRecord, createApiMask } from 'services/ReportService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
import { activeStatus } from 'components/helper'
injectReducer('inventoryReports', reducer)

export default function InventoryReports() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(state => state.inventoryReports.data)
    const { company, customer } = useSelector(state => state.filterData)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        company,
        customer,
    ])

    const fetchData = () => dispatch(getData({ ...tableData, company: company, customer: customer }))

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleStatus = (id, data) => {
        updateApiRecord(id, data)
            .then(() => {
                Success('Status Updated Successfully!')
                fetchData()
            })
            .catch(error => console.log('Error: ', error))
    }

    const columns = useMemo(
        () => [
            {
                field: 'company_code',
                header: 'Company',
                className: 'min-w-[150px]',
                hide: false,
            },
            {
                field: 'customer_code',
                header: 'Customer',
                className: 'min-w-[150px]',
                hide: false,
            },
            {
                field: 'report_name',
                header: 'Name',
                className: 'min-w-[150px]',
                hide: false,
            },
            {
                field: 'status',
                header: 'Status',
                hide: false,
                renderCell: row => {
                    return checkPermission('inventory', 'edit') ? (
                        <ConfirmationModal
                            onConfirm={() => {
                                handleStatus(row.id, { is_active: !row.is_active })
                            }}
                        >
                            {activeStatus(row.is_active)}
                        </ConfirmationModal>
                    ) : (
                        activeStatus(row.is_active)
                    )
                },
            },
            {
                field: 'action',
                header: 'Action',
                className: 'px-4',
                hide: false,
                renderCell: row => {
                    return (
                        <div className="flex items-center gap-3">
                            {/* {checkPermission('reports', 'view') ? ( */}
                            <Tooltip title={'View'}>
                                <span
                                    className="hover:text-primary cursor-pointer"
                                    onClick={() => {
                                        createApiMask(row.id)
                                            .then(response => {
                                                const data = response?.data || {}
                                                if (data.mode === 'direct' && data.direct_url) {
                                                    window.open(data.direct_url, '_blank')
                                                    return
                                                }
                                                if (data.masked_url) {
                                                    const base = process.env.REACT_APP_URL || window.location.origin || ''
                                                    window.open(`${base}/api/v1/report-management${data.masked_url}`, '_blank')
                                                    return
                                                }
                                                console.warn('No URL returned for report open')
                                            })
                                            .catch(error => console.log('Error: ', error))
                                    }}
                                >
                                    <HiOutlineEye size={20} />
                                </span>
                            </Tooltip>
                            {/* ) : null} */}
                            {checkPermission('inventory', 'edit') ? (
                                <Tooltip title={'Edit'}>
                                    <Link to={`/meson-insights/inventory/${row.id}/edit`} className="hover:text-primary">
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission('inventory', 'delete') ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={'Are you sure you want to delete this record!'}
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Reports-Inventory</h2>
            </div>
            <Table
                loading={loading}
                filter={false}
                datas={data}
                columns={columns}
                add_new={checkPermission('inventory', 'create') ? '/meson-insights/inventory/create' : ''}
                pagingData={tableData}
                onChange={e => dispatch(setTableData(e))}
            />
        </>
    )
}
